import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  LinearProgress,
  Button,
  Box,
  Chip,
  Stack,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import GroupIcon from '@mui/icons-material/Group';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const ProjectCard = ({
  startupId,
  logoSrc,
  projectSrc,
  title,
  description,
  highestInvestment,
  campaignEndDate,
  fundedAmount,
  targetAmount,
  investors,
  status, // "successful", "unsuccessful", or "funded"
  isOwner = false // yeni prop eklendi
}) => {
  console.log(startupId);
  const navigate = useNavigate();

  const progress = (fundedAmount / targetAmount) * 100;

  const statusColors = {
    successful: { color: "success", label: "Başarılı" },
    unsuccessful: { color: "error", label: "Başarısız" },
    funded: { color: "warning", label: "Fonlandı" },
    PENDING: { color: "warning", label: "Bekliyor" },
    WAITING_REVIEW: { color: "info", label: "İncelemede" },
    APPROVED: { color: "success", label: "Aktif" }
  };

  const handleEditClick = () => {
    // isOwner durumuna göre farklı sayfalara yönlendir
    if (isOwner) {
      navigate(`/kampanyalar/kayit/${startupId}`);
    } else {
      navigate(`/kampanyalar/detay/${startupId}`);
    }
  };

  return (
    <Card
      sx={{
        maxWidth: 400,
        borderRadius: 3,
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 12px 32px rgba(0,0,0,0.18)",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <CardMedia
          component="img"
          height="200"
          image={projectSrc}
          alt={title}
          sx={{
            position: "relative",
            objectFit: "cover",
            width: "300px",
            aspectRatio: "16/9"
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 16,
            left: 16,
            right: 16,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Chip
            label={statusColors[status]?.label}
            color={statusColors[status]?.color}
            size="small"
            sx={{ fontWeight: 600 }}
          />
          <Box
            component="img"
            src={logoSrc}
            alt="Logo"
            sx={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              border: "2px solid #fff",
              backgroundColor: "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          />
        </Box>
      </Box>

      <CardContent sx={{ pt: 3 }}>
        <Typography variant="h6" gutterBottom fontWeight="bold">
          {title}
        </Typography>

        <Stack spacing={2} sx={{ mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <AccessTimeIcon color="action" fontSize="small" />
            <Typography variant="body2" color="text.secondary">
              Bitiş: {campaignEndDate}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Tooltip title="En Yüksek Yatırım">
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TrendingUpIcon color="success" />
                <Typography variant="subtitle2">
                  {highestInvestment} TRY
                </Typography>
              </Box>
            </Tooltip>
            <Tooltip title="Yatırımcı Sayısı">
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <GroupIcon color="primary" />
                <Typography variant="subtitle2">
                  {investors}
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </Stack>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Toplanan
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Hedef
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="subtitle2" fontWeight="bold">
              {fundedAmount} TRY
            </Typography>
            <Typography variant="subtitle2" fontWeight="bold">
              {targetAmount} TRY
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 8,
              borderRadius: 4,
              backgroundColor: "rgba(0,0,0,0.08)",
              "& .MuiLinearProgress-bar": {
                borderRadius: 4,
                backgroundColor: progress >= 100 ? "#2e7d32" : "#1976d2",
              },
            }}
          />
        </Box>

        <Button
          fullWidth
          variant="contained"
          onClick={handleEditClick}
          disabled={status === "WAITING_REVIEW"}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            py: 1.5,
            fontWeight: 600,
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          {status === "WAITING_REVIEW" 
            ? "İncelemede" 
            : isOwner ? "Düzenle" : "İncele"}
        </Button>
      </CardContent>
    </Card>
  );
};

export default ProjectCard;
